export default __webpack_public_path__ + "media/images/mailer/icon_grade-0885b314e3b57fbc8818a40caa3657b0.png";